// @ts-nocheck

import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import Swipe, { type SwipeProps } from '../../../../components/Swipe';

import { KLViewContext } from './KLViewWrapper';

const StyledSwipe = styled(Swipe)`
  ${({ $height }) => {
    if ($height)
      return css`
        height: ${$height}px;
      `;
  }}
`;

const KLSwipe = (props: SwipeProps) => {
  const { height: availableHeight } = useContext(KLViewContext);

  return <StyledSwipe {...props} $height={availableHeight} />;
};

export default KLSwipe;
